import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUsers as apiEditUsers } from "../../api/apiUsers";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateUsers() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: editUsers,
        isPending: isUpdate,
        data: results,
        error,
    } = useMutation({
        mutationFn: ({ req, id }) => apiEditUsers(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["users"] });
            navigate('/users');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editUsers, isUpdate, error, results };
}
